<template>
    <el-card class="page_card" v-loading="!is_ok">
        <div slot="header" class="clearfix">
            <el-page-header @back="goBack" content="计划单详情"></el-page-header>
        </div>
        <el-row>
            <el-col :span="16">
                <span>计划单基本信息</span>
                <el-divider></el-divider>
                <el-form label-width="120px" style="border-right: 1px solid #dedede">
                    <el-row>
                        <el-col :span="12" v-if="data && data.baseInfo">
                            <el-form-item label="企业名称:">
                                {{data.baseInfo.comName}}
                            </el-form-item>
                            <el-form-item label="计划日期:">
                                {{data.baseInfo.planDate}}
                            </el-form-item>
                            <el-form-item label="下单时间:">
                                {{data.baseInfo.addTime}}
                            </el-form-item>
                            <el-form-item label="计划单编号:">
                                {{data.baseInfo.orderSn}}
                            </el-form-item>
                            <el-form-item label="计划单状态:">
                                <el-link :type="statusType(data.baseInfo.status)">{{parseStatus(data.baseInfo.status)}}</el-link>
                            </el-form-item>
                            <el-form-item label="下单人:">
                                {{data.baseInfo.creatorName}}
                            </el-form-item>
                            <el-form-item label="下单人电话:">
                                {{data.baseInfo.creatorMobile}}
                            </el-form-item>
                            <el-form-item label="采购产品:">
                                {{data.baseInfo.goodsName}}
                            </el-form-item>
                            <!-- <el-form-item label="计划单类型:">
                                <el-link :underline="false" type="primary" v-if="data.baseInfo.purchaseType == 0">本厂计划</el-link>
                                <el-link :underline="false" type="warning" v-if="data.baseInfo.purchaseType == 1">采购计划</el-link>
                                <el-link :underline="false" type="primary" v-if="data.baseInfo.purchaseType == 2">临时计划</el-link>
                                <el-link :underline="false" type="warning" v-if="data.baseInfo.purchaseType == 10">其他计划</el-link>
                            </el-form-item> -->
                            <el-form-item label="提货方式:">
                                <el-link :underline="false" type="primary" v-if="data.baseInfo.deliverType == 0">自提</el-link>
                                <el-link :underline="false" type="warning" v-if="data.baseInfo.deliverType == 1">配送</el-link>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" v-if="data && data.baseInfo">
                            <el-form-item label="主车号:">
                                <span>{{data.baseInfo.plateNumber}}</span>
                            </el-form-item>
                            <el-form-item label="挂车号:">
                                <span>{{data.baseInfo.carriageNumber}}</span>
                            </el-form-item>
                            <el-form-item label="驾驶员:">
                                <span>{{data.baseInfo.driverName}}</span>
                            </el-form-item>
                            <el-form-item label="驾驶员电话:">
                                <span>{{data.baseInfo.driverMobile}}</span>
                            </el-form-item>
                            <el-form-item label="押运员:">
                                <span>{{data.baseInfo.escortName}}</span>
                            </el-form-item>
                            <el-form-item label="押运员电话:">
                                <span>{{data.baseInfo.escortMobile}}</span>
                            </el-form-item>
                            <el-form-item label="物流公司:">
                                <el-link :underline="false" type="primary">{{data.baseInfo.expressName}}</el-link>
                            </el-form-item>
                            <el-form-item label="卸液地:">
                                <div v-if="JSON.parse(data.baseInfo.destinations).length">
                                    <div v-for="(item,index) of JSON.parse(data.baseInfo.destinations)" :key="index">
                                        <el-tag type="primary">{{item}}</el-tag>
                                    </div>
                                </div>
                                <div v-else>
                                    无
                                </div>
                            </el-form-item>
                            <el-form-item label="">
                                 <el-button type="warning" plain :loading="is_post" v-can="['btn:amount']" @click="amountBtn(data)" v-if="data.baseInfo.status < 10">修改装液量</el-button>
                                <el-button type="warning" plain :loading="is_post" v-can="['btn:modifying_basic_information']" @click="editBtn" v-if="data.baseInfo.status < 30">修改基本信息</el-button>
                                <!-- <el-button type="warning" plain :loading="is_post" @click="editBtn" v-if="data.baseInfo.status < 21 && has_permission('btn:change_base')">修改基本信息</el-button> -->
                                <el-button type="warning" plain :loading="is_post" @click="add_weight_btn" v-if="data.baseInfo.purchaseType == 1 && data.baseInfo.status < 30 && has_permission('btn:add_pound')">补录磅单</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <span>计划单金额信息</span>
                <el-divider></el-divider>
                <el-form label-width="120px" v-if="data && data.moneyInfo && data.baseInfo" style="border-right: 1px solid #dedede;padding-right: 10px">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="计划装货量:">
                                <el-link :underline="false" type="primary">{{data.moneyInfo.planWeight}} 吨</el-link>
                            </el-form-item>
                            <el-form-item label="实际装货量:" v-if="data.moneyInfo.netWeight">
                                <el-link :underline="false" type="primary">{{data.baseInfo.finalWeight}} 吨</el-link>
                            </el-form-item>
                            <el-form-item label="挂牌价:">
                                <el-link :underline="false" type="success">{{data.moneyInfo.letterPrice}} 元/吨</el-link>
                            </el-form-item>
                            <!-- <el-form-item label="实际价格:">
                                <el-link :underline="false" type="primary">{{data.moneyInfo.realPrice}} 元/吨</el-link>
                            </el-form-item> -->
                            <el-form-item label="长期优惠:">
                                <el-link :underline="false" type="warning">{{data.moneyInfo.temCut}} 元/吨</el-link>
                            </el-form-item>
                            <el-form-item label="销售员优惠:">
                                <el-link :underline="false" type="warning">{{data.moneyInfo.saleCut}} 元</el-link>
                            </el-form-item>
                             <el-form-item label="车辆优惠:">
                                <el-link :underline="false" type="warning">{{data.moneyInfo.carCut}} 元</el-link>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="其他费用:">
                                <el-table size="mini" border :data="JSON.parse(data.moneyInfo.otherFee)" empty-text="无其他费用">
                                    <el-table-column label="费用名录">
                                        <template slot-scope="scope">
                                            {{scope.row.name}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="费用">
                                        <template slot-scope="scope">
                                            ￥ {{scope.row.num}}
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-form-item>
                            <el-form-item label="成交价:">
                                <el-link :underline="false" type="success">{{data.moneyInfo.tradingPrice}} 元/吨</el-link>
                            </el-form-item>
                            <el-form-item label="实际总金额:">
                                <el-link :underline="false" type="success" v-show="data.moneyInfo.realAmount != null">{{data.moneyInfo.realAmount}} 元</el-link>
                            </el-form-item>
                            <!-- <el-form-item label="下单前客户余额:">
                                <el-link :underline="false" type="primary">{{data.moneyInfo.prePlanBalance}} 元</el-link>
                            </el-form-item>
                            <el-form-item label="下单后客户余额:">
                                <el-link :underline="false" type="success">{{data.moneyInfo.afterPlanBalance}} 元</el-link>
                            </el-form-item> -->
                            <el-form-item label="">
                                <!-- <el-button type="warning" plain @click="editPrice" v-if="data.baseInfo.status < 10 && has_permission('btn:change_price')">调 价</el-button> -->
                                <el-button v-can="['btn:change_fee']" type="warning" plain @click="setOtherFee" v-if="data.baseInfo.status < 10">设置其他费用</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <!-- 磅单信息此处内容做了修改，如果后续出现错误，请cv大法client-detail.vue文件中的磅单信息 -->
                <span v-if="data && data.weightInfo && data.baseInfo.status >= 30">磅单信息</span>
                <el-divider v-if="data && data.weightInfo && data.baseInfo.status >= 30"></el-divider>

                <el-button  v-if="data && data.weightInfo && data.baseInfo.status >= 30" type="warning" v-can="['btn:settlement_update']" style="margin-left:85%;" plain :loading="is_post" @click="settlementUpdateBtn(data)">更新结算信息</el-button>
                <el-form label-width="120px" style="border-right: 1px solid #dedede;padding-right: 10px" v-if="data && data.weightInfo && data.baseInfo.status >= 30">
                    <el-row>
                        <el-col :span="24" v-if="data && data.weightInfo">
                            <el-row>
                                <el-form-item label="铅封号:" v-if="data && data.weightInfo && data.weightInfo.leadSealNo">
                                    <el-link :underline="false" type="primary">{{data.weightInfo.leadSealNo}}</el-link>
                                </el-form-item>
                            </el-row>
                            <el-row>
                                <el-col :span="8">
                                     <el-form-item label="磅单1打印时间:" v-if="data && data.weightInfo && data.weightInfo.firstWeightTime">
                                        {{data.weightInfo.printPoundTime}}
                                        <el-link v-if='data && data.weightInfo && data.weightInfo.firstWeightTime' :underline="false" type="primary" @click="getPoundData(data.weightInfo.poundSn)">查看电子磅单</el-link>
                                    </el-form-item>
                                    <el-form-item label="磅单编号:" v-if='data.weightInfo.poundSn'>
                                        {{data.weightInfo.poundSn}}
                                    </el-form-item>
                                    <el-form-item label="皮重(吨):" v-if="data && data.weightInfo && data.weightInfo.firstWeight">
                                       <el-link :underline="false">{{data.weightInfo.firstWeight}} 吨</el-link>
                                    </el-form-item>
                                    <el-form-item label="毛重(吨):" v-if="data && data.weightInfo && data.weightInfo.secondWeight">
                                        <el-link :underline="false" type="warning">{{data.weightInfo.secondWeight}} 吨</el-link>
                                    </el-form-item>
                                    <el-form-item label="一次称重时间:" v-if="data.weightInfo.firstWeightTime">
                                        {{data.weightInfo.firstWeightTime}}
                                    </el-form-item>
                                    <el-form-item label="二次称重时间:" v-if="data.weightInfo.secondWeightTime">
                                        {{data.weightInfo.secondWeightTime}}
                                    </el-form-item>
                                    <el-form-item label="净重(吨):" v-if="data && data.weightInfo && data.weightInfo.netWeight">
                                        <el-link :underline="false" type="primary">{{data.weightInfo.netWeight}} 吨</el-link>
                                    </el-form-item>
                                    <!-- <el-form-item label="二次过磅时间:" v-if="data && data.weightInfo && data.weightInfo.secondWeightTime">
                                        {{data.weightInfo.secondWeightTime}}
                                    </el-form-item> -->

                                </el-col>
                                <el-col :span="8" v-for='(item,index) in data.weightInfo.manyLoadSheets' :key='index'>
                                     <el-form-item :label="'磅单'+(index+2)+'打印时间:'" v-if="data.weightInfo.printPoundTime">
                                        {{data.weightInfo.printPoundTime}}
                                        <el-link v-if='data && data.weightInfo && data.weightInfo.printPoundTime' :underline="false" type="primary" @click="getPoundData(item.poundSn)">查看电子磅单</el-link>
                                    </el-form-item>
                                    <el-form-item label="磅单编号:" v-if='item.poundSn'>
                                        {{item.poundSn}}
                                    </el-form-item>
                                    <el-form-item label="皮重(吨):" v-if="item.firstWeight||item.firstWeight==0">
                                        {{item.firstWeight}} 吨
                                    </el-form-item>
                                    <el-form-item label="毛重(吨):" v-if="item.secondWeight||item.secondWeight==0">
                                        <el-link :underline="false" type="warning">{{item.secondWeight}} 吨</el-link>
                                    </el-form-item>
                                    <el-form-item label="一次称重时间:" v-if="item.firstWeightTime">
                                        {{item.firstWeightTime}}
                                    </el-form-item>
                                    <el-form-item label="二次称重时间:" v-if="item.secondWeightTime">
                                        {{item.secondWeightTime}}
                                    </el-form-item>
                                    <el-form-item label="净重(吨):" v-if="item.netWeight||item.netWeight==0">
                                        <el-link :underline="false" type="primary">{{item.netWeight}} 吨</el-link>
                                    </el-form-item>
                                    <!-- <el-form-item label="二次过磅时间:" v-if="item.secondWeightTime">
                                        {{item.secondWeightTime}}
                                    </el-form-item> -->
                                    <!-- <el-form-item label="铅封号:" v-if="item.leadSealNo">
                                        <el-link :underline="false" type="primary">{{item.leadSealNo}}</el-link>
                                    </el-form-item> -->
                                </el-col>
                            </el-row>
                        </el-col>
                        <!-- <el-col :span="7">
                            <el-form-item label="附件:">
                                <div class="previews" v-if="data && data.weightInfo && data.weightInfo.files && data.weightInfo.files.length">
                                    <div :class="file.fileType == 'pdf'?'preview pdf':'preview image'" v-for="(file,index) of data.weightInfo.files" :key="index">
                                        <div class="pdf_icon" v-if="file.fileType=='pdf'">
                                            <svg-icon icon-class="pdf2" />
                                        </div>
                                        <div class="text" v-if="file.fileType=='pdf'">
                                            {{file.name}}
                                        </div>
                                        <div class="img" v-else style="width: 160px;height: 140px">
                                            <el-image fit="cover" style="width: 160px;height: 140px;border-radius:10px;" :src="file.url"></el-image>
                                        </div>
                                        <div :class="file.fileType == 'pdf'?'btns':'img_btns'">
                                            <el-link style="margin-right: 5px;font-size: 1.2em" :underline="false" @click="preview(file,index)" size="mini" type="primary"><i class="el-icon-search" /></el-link>
                                        </div>
                                    </div>
                                </div>
                                <div class="warning_text" v-else>
                                    无
                                </div>
                            </el-form-item>
                            <el-form-item label="" v-if="has_permission('btn:add_order_file')">
                                <div style="font-size: 12px;color: #aaa">只能上传jpg,jpeg,png,gif,pdf格式的文件,最大不超过20MB</div>
                                <el-button type="success" plain @click="upload_file_btn" :loading="is_post || is_upload"><i class="el-icon-upload" /> 上传附件</el-button>

                                <input type="file" name="addFile" @change="file_change($event)" ref="addFile" style="display:none">
                            </el-form-item>
                        </el-col> -->
                    </el-row>
                </el-form>
                <span>附件</span>
                <el-divider></el-divider>
                <el-form label-width="120px" style="border-right: 1px solid #dedede;padding-right: 10px">
                    <el-row>
                        <el-col :span="7">
                            <el-form-item label="附件:">
                                <div class="previews" v-if="data && data.weightInfo && data.weightInfo.files && data.weightInfo.files.length">
                                    <div :class="file.fileType == 'pdf'?'preview pdf':'preview image'" v-for="(file,index) of data.weightInfo.files" :key="index">
                                        <div class="pdf_icon" v-if="file.fileType=='pdf'">
                                            <svg-icon icon-class="pdf2" />
                                        </div>
                                        <div class="text" v-if="file.fileType=='pdf'">
                                            {{file.name}}
                                        </div>
                                        <div class="img" v-else style="width: 160px;height: 140px">
                                            <el-image fit="cover" style="width: 160px;height: 140px;border-radius:10px;" :src="file.url"></el-image>
                                        </div>
                                        <div :class="file.fileType == 'pdf'?'btns':'img_btns'">
                                            <el-link style="margin-right: 5px;font-size: 1.2em" :underline="false" @click="preview(file,index)" size="mini" type="primary"><i class="el-icon-search" /></el-link>
                                        </div>
                                    </div>
                                </div>
                                <div class="warning_text" v-else>
                                    无
                                </div>
                            </el-form-item>
                            <el-form-item label="" v-can="['btn:current_plan_attached']">
                                <div style="font-size: 12px;color: #aaa">只能上传jpg,jpeg,png,gif,pdf格式的文件,最大不超过20MB</div>
                                <el-button type="success" plain  v-can="['btn:current_plan_attached']" @click="upload_file_btn" :loading="is_post || is_upload"><i class="el-icon-upload" /> 上传附件</el-button>

                                <input type="file" name="addFile" @change="file_change($event)" ref="addFile" style="display:none">
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

                <span v-if="data && data.securityInfo && data.baseInfo.status == 30">安全检查信息</span>
                <el-divider v-if="data && data.securityInfo && data.baseInfo.status == 30"></el-divider>
                <el-row v-if="data && data.securityInfo && data.baseInfo.status == 30" style="margin-bottom: 20px;">
                    <el-tabs type="border-card">
                        <div>
                            <span style="margin-right: 6%;">槽车充装检验单</span>
                            <el-button plain type="success" v-can="['btn:tank_truck_filling_inspection_list']" @click="exportExcel"> <svg-icon icon-class="xls" /> 导出</el-button>
                        </div>
                        <!-- <el-tab-pane label="槽车充装检验单">
                            <el-form label-width="140px">
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item v-if="data.securityInfo.plateNumber" label="主车号:">
                                            {{data.securityInfo.plateNumber}}
                                        </el-form-item>
                                        <el-form-item v-if="data.securityInfo.carriageNumber" label="挂车号:">
                                            {{data.securityInfo.carriageNumber}}
                                        </el-form-item>
                                        <el-form-item v-if="data.securityInfo.driverIdNumber" label="司机身份证:">
                                            {{data.securityInfo.driverIdNumber}}
                                        </el-form-item>
                                        <el-form-item v-if="data.securityInfo.tankerSn" label="罐车编号:">
                                            {{data.securityInfo.tankerSn}}
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item v-if="data.securityInfo.tankerLastCheckTime" label="上次罐体检验日期:">
                                            {{data.securityInfo.tankerLastCheckTime}}
                                        </el-form-item>
                                        <el-form-item v-if="data.securityInfo.tankerCheckCertSn" label="罐体检验证编号:">
                                            {{data.securityInfo.tankerCheckCertSn}}
                                        </el-form-item>
                                        <el-form-item v-if="data.securityInfo.maxFilling" label="最大充装量(吨):">
                                            {{data.securityInfo.maxFilling}}
                                        </el-form-item>
                                        <el-form-item v-if="data.securityInfo.escortIdNumber" label="押运证号:">
                                            {{data.securityInfo.escortIdNumber}}
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </el-tab-pane> -->
                        <!-- <el-tab-pane label="充装前检查" v-if="data.securityInfo.preLoadCheck && data.securityInfo.preLoadCheck != '[]'">
                            <el-form label-width="200px">
                                <el-row>
                                    <el-col :span="12" v-for="item of JSON.parse(data.securityInfo.preLoadCheck)">
                                        <el-form-item :label="item.keyName">
                                            <el-link :type="typeof item.value == 'boolean'?(item.value?'success':'danger'):'primary'" :underline="false">{{item.valueName}}</el-link>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </el-tab-pane>
                        <el-tab-pane label="充装中检查" v-if="data.securityInfo.loadingCheck && data.securityInfo.loadingCheck != '[]'">
                            <el-form label-width="270px">
                                <el-row>
                                    <el-col :span="12" v-for="item of JSON.parse(data.securityInfo.loadingCheck)">
                                        <el-form-item :label="item.keyName">
                                            <el-link :type="typeof item.value == 'boolean'?(item.value?'success':'danger'):'primary'" :underline="false">{{item.valueName}}</el-link>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </el-tab-pane>
                        <el-tab-pane label="充装后检查" v-if="data.securityInfo.afterLoadCheck && data.securityInfo.afterLoadCheck != '[]'">
                            <el-form label-width="300px">
                                <el-row>
                                    <el-col :span="12" v-for="item of JSON.parse(data.securityInfo.afterLoadCheck)">
                                        <el-form-item :label="item.keyName">
                                            <el-link :type="typeof item.value == 'boolean'?(item.value?'success':'danger'):'primary'" :underline="false">{{item.valueName}}</el-link>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </el-tab-pane> -->
                    </el-tabs>
                </el-row>
                <span>计划单备注信息</span>
                <el-divider></el-divider>
                <div style="padding: 0 20px;font-size: 14px">
                    <el-input type="textarea" v-model="remark" maxlength="100" show-word-limit :autosize="{ minRows: 4, maxRows: 8}" placeholder="备注信息"></el-input>
                    <el-button type="warning" plain style="margin-top: 20px" v-can="['btn:current_plan_sheet_remarks']" @click="update_remark" :loading="is_post">更新备注</el-button>
                </div>
            </el-col>
            <el-col :span="8">
                计划单变动信息
                <el-divider></el-divider>
                <el-timeline v-if="data && data.timelines">
                    <el-timeline-item :key="item.id" v-for="item of data.timelines" :timestamp="item.addTime" placement="top">
                        <el-card>
                            <p v-if="item.name && item.jobName"><el-link :underline="false" type="primary">{{item.name}} {{parseChangeType(item.actionType)}}</el-link> ({{item.jobName}})</p>
                            <p v-else><el-link :underline="false" type="warning">{{parseChangeType(item.actionType)}}</el-link></p>
                            <p v-if="item.isChange">
                                <el-link :type="statusType(parseInt(item.statusChange.split('->')[0]))" :underline="false">
                                    {{parseStatus(parseInt(item.statusChange.split("->")[0]))}}
                                </el-link>->
                                <el-link :type="statusType(parseInt(item.statusChange.split('->')[1]))" :underline="false">
                                    {{parseStatus(parseInt(item.statusChange.split("->")[1]))}}
                                </el-link>
                            </p>
                            <el-table :data="JSON.parse(item.changeContent)" v-if="item.changeContent != '[]'">
                                <el-table-column label="名称">
                                    <template slot-scope="scope">
                                        {{scope.row.key}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="旧值">
                                    <template slot-scope="scope">
                                        <el-link type="warning" :underline="false">
                                            {{scope.row.oldValue}}
                                        </el-link>
                                    </template>
                                </el-table-column>
                                <el-table-column label="最新值">
                                    <template slot-scope="scope">
                                        <el-link type="success" :underline="false">
                                            {{scope.row.newValue}}
                                        </el-link>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-card>
                    </el-timeline-item>
                </el-timeline>
            </el-col>
        </el-row>

        <el-dialog title="电子磅单" :visible.sync="pound_dialog" width="40%" top="12vh">
            <poundDetail :baseInfo="poundInfo"></poundDetail>
        </el-dialog>>

        <el-dialog title="修改基本信息" :visible.sync="edit_dialog" width="30%">
            <el-form :model="editForm" ref="editForm" v-if="data && data.baseInfo && data.moneyInfo" :rules="editRules" label-width="120px">
                <el-form-item label="计划日期" prop="planDate">
                    <el-select v-model="editForm.planDate" placeholder="请选择计划日期" style="width:100%">
                        <el-option
                            v-for="item in dates"
                            :key="item"
                            :label="item"
                            :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="物流公司" prop="expressName">
                    <el-autocomplete
                        style="width: 100%"
                        class="inline-input"
                        v-model="editForm.expressName"
                        :fetch-suggestions="querySearchExpressName"
                        placeholder="请输入物流公司名称"
                        :trigger-on-focus="false"
                        :maxlength="20"
                        show-word-limit
                    ></el-autocomplete>
                </el-form-item>
                <el-form-item label="主车号" prop="plateNumber">
                    <el-input v-model="editForm.plateNumber" :maxlength="7" show-word-limit placeholder="请输入主车号"></el-input>
                </el-form-item>
                <el-form-item label="挂车号" prop="carriageNumber">
                    <el-input v-model="editForm.carriageNumber" :maxlength="7" show-word-limit placeholder="请输入挂车号"></el-input>
                </el-form-item>
                <el-form-item label="驾驶员" prop="driverName">
                    <el-input v-model="editForm.driverName" placeholder="请输入驾驶员" :maxlength="10" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="驾驶员电话" prop="driverMobile">
                    <el-input v-model="editForm.driverMobile" placeholder="请输入驾驶员电话" :maxlength="11" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="押车员" prop="escortName">
                    <el-input v-model="editForm.escortName" placeholder="请输入押车员" :maxlength="10" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="押车员电话" prop="escortMobile">
                    <el-input v-model="editForm.escortMobile" placeholder="请输入押车员电话" :maxlength="11" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="提货方式" prop="escortMobile">
                    <el-radio v-model="editForm.deliverType" :label="0">自提</el-radio>
                    <el-radio v-model="editForm.deliverType" :label="1">配送</el-radio>
                </el-form-item>
                <el-form-item label="卸液地" v-if="editForm.deliverType == 1">
                    <el-input type="textarea" v-model="editForm.destinations"></el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="warning" plain :loading="is_post" @click="editSubmit">提交修改</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog title="调价" :visible.sync="edit_price_dialog" width="25%">
            <el-alert show-icon title="注意" :closable="false" description="成交价 = 实际价格 - 长期优惠 - 销售员优惠" type="warning" style="margin-bottom: 20px"></el-alert>
            <el-form :model="priceForm" ref="priceForm" :rules="priceRules" label-width="120px">
                <el-form-item label="实际价格(元/吨)" prop="realPrice">
                    <el-input v-model="priceForm.realPrice" placeholder="请输入实际价格"></el-input>
                </el-form-item>
                <el-form-item label="销售员优惠(元/吨)" prop="saleCutPrice">
                    <el-input v-model="priceForm.saleCutPrice" placeholder="请输入销售员优惠额"></el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-button plain type="primary" :loading="is_post" @click="submitPriceChange">提 交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog title="补录磅单" :visible.sync="add_file_dialog" width="30%">
            <el-form :model="weightForm" ref="weightForm" :rules="weightRules" label-width="120px">
                <el-form-item label="皮重(kg)" prop="firstWeight">
                    <el-input v-model="weightForm.firstWeight" placeholder="请输入磅单皮重(kg)"></el-input>
                </el-form-item>
                <el-form-item label="毛重(kg)" prop="lastWeight">
                    <el-input v-model="weightForm.lastWeight" placeholder="请输入磅单毛重(kg)"></el-input>
                </el-form-item>
                <el-form-item label="净重(kg)" prop="netWeight">
                    <el-input v-model="weightForm.netWeight" placeholder="请输入磅单净重(kg)"></el-input>
                </el-form-item>
                <el-form-item label="一次过磅时间" prop="startTime">
                    <el-date-picker
                        v-model="weightForm.startTime"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="二次过磅时间" prop="endTime">
                    <el-date-picker
                        v-model="weightForm.endTime"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        type="datetime"
                        placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="磅单附件">
                    <el-upload
                        class="upload-demo"
                        drag
                        action=""
                        list-type="text"
                        :show-file-list="false"
                        :before-upload="beforeUpload"
                        :http-request="uploadFile"
                        :limit="16"
                        multiple>
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" slot="tip">只能上传pdf/jpg/png文件，最大不超过20MB,最多上传4个文件</div>
                    </el-upload>
                    <el-row class="previews">
                        <div :class="file.type == 'pdf'?'preview pdf':'preview image'" v-for="(file,index) of fileList" :key="file.url">
                            <div class="pdf_icon" v-if="file.type=='pdf'">
                                <svg-icon icon-class="pdf2" />
                            </div>
                            <div class="text" v-if="file.type=='pdf'">
                                {{file.name}}
                            </div>
                            <div class="img" v-else style="width: 160px;height: 140px">
                                <el-image fit="cover" style="width: 160px;height: 140px;border-radius:10px;" :src="file.url"></el-image>
                            </div>
                            <div :class="file.type == 'pdf'?'btns':'img_btns'">
                                <el-link style="margin-right: 5px;font-size: 1.2em" :underline="false" @click="preview(file,index)" size="mini" type="primary"><i class="el-icon-search" /></el-link>
                                <el-link style="margin-left: 5px;font-size: 1.2em" :underline="false" @click="delFile(file,index)" size="mini" type="danger"><i class="el-icon-circle-close" /></el-link>
                            </div>
                        </div>
                    </el-row>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" plain :loading="is_post" @click="add_weight_submit">提 交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog title="文件预览" :visible.sync="preview_dialog" width="60%">
            <el-row>
                <el-col :span="24" style="overflow-x: hidden;overflow-y: auto;height: 65vh" v-if="preview_file && preview_file.fileType != 'pdf'">
                    <el-image fit="cover" style="width: 100%" :src="preview_file.url" v-if="preview_file"></el-image>
                </el-col>
                <el-col :span="24" style="overflow-x: hidden;overflow-y: auto;height: 65vh" v-loading="is_show_pdf" v-if="preview_file && preview_file.fileType == 'pdf'">
                    <pdf ref="pdf"
                         style="width: 100%"
                         v-for="i in numPages"
                         :key="i"
                         :src="preview_file.url"
                         :page="i"></pdf>
                </el-col>
            </el-row>
        </el-dialog>

        <el-dialog title="设置其他费用" :visible.sync="other_fee_dialog" width="30%">
            <el-button size="mini" style="margin-bottom: 15px" type="success" plain @click="add_other_fee_dialog = !add_other_fee_dialog">添加其他费用</el-button>
            <el-table :data="fee_data" border>
                <el-table-column label="费用名称">
                    <template slot-scope="scope">
                        {{scope.row.name}}
                    </template>
                </el-table-column>
                <el-table-column label="费用金额(元)">
                    <template slot-scope="scope">
                        <el-link :underline="false" type="warning">￥ {{scope.row.num}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-link type="danger" :underline="false" size="mini" @click="delOther(scope.$index)"><i class="el-icon-delete"></i></el-link>
                    </template>
                </el-table-column>
            </el-table>
            <el-button type="warning" size="mini" style="margin-top: 15px" plain @click="saveOtherFee" :loading="is_post">保 存</el-button>
        </el-dialog>

        <el-dialog title="添加其他费用" :visible.sync="add_other_fee_dialog" width="25%">
            <el-form label-width="140px" ref="addOtherForm" :model="addOtherForm" :rules="feeRules">
                <el-form-item label="其他费用名称" prop="name">
                    <el-input v-model="addOtherForm.name" placeholder="请输入其他费用名称" maxlength="10" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="其他费用金额(元)" prop="num">
                    <el-input v-model="addOtherForm.num" placeholder="请输入其他费用金额(元)" maxlength="10" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" plain @click="addOther" size="mini">提 交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog title="修改计划量" :visible.sync="setLeadDialog" width="25%">
            <el-form :model="leadForm" ref="leadForm" :rules="weigthForms" label-width="100px" >
                <el-form-item label="修改计划量" prop="weight">
                    <el-input type="text" placeholder="输入修改计划量" v-model="leadForm.weight"></el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" plain :loading="is_post" @click="setLeadSubmit">提 交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog title="完结计划更新" :visible.sync="settlementUpdateDialog" width="25%">
            <el-form :model="settlementUpdateForm" ref="settlementUpdateForm" :rules="settlementUpdateRules" label-width="120px" >
                <el-form-item label="计划编号：" prop="orderSn" style="margin-bottom:8px;">
                    {{data.baseInfo.orderSn}}
                </el-form-item>
                <el-form-item label="企业名称：" prop="comName" style="margin-bottom:8px;">
                    {{data.baseInfo.comName}}
                </el-form-item>
                <el-form-item label="结算单价：" prop="price" style="margin-bottom:8px;">
                    <div class="switch-style">
                        <el-input type="text" @change="handlerPrice" :disabled="!settleUnitPriceSwitch" v-model="settlementUpdateForm.price"></el-input>
                        <el-switch v-model="settleUnitPriceSwitch" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                    </div>
                </el-form-item>
                <el-form-item label="磅单选择：" prop="poundSn" style="margin-bottom:8px;width:86%;">
                    <el-select v-model="settlementUpdateForm.poundSn" @change="changePoundSn" style="width:100%">
                        <el-option v-for="(item,index) in poundSnList" :key="index" :label="item.poundSn" :value="item.poundSn">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="主车号：" prop="plateNumber" style="margin-bottom:8px;">
                    <div class="switch-style">
                        <el-input type="text" :disabled="!plateNumberSwitch" v-model="settlementUpdateForm.plateNumber"></el-input>
                        <el-switch v-model="plateNumberSwitch" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                    </div>
                </el-form-item>
                <el-form-item label="挂车号：" prop="carriageNumber" style="margin-bottom:8px;">
                    <div class="switch-style">
                        <el-input type="text" :disabled="!carriageNumberSwitch" v-model="settlementUpdateForm.carriageNumber"></el-input>
                        <el-switch v-model="carriageNumberSwitch" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                    </div>
                </el-form-item>
                <el-form-item label="驾驶员姓名：" prop="driver" style="margin-bottom:8px;">
                    <div class="switch-style">
                        <el-input type="text" :disabled="!driverNameSwitch" v-model="settlementUpdateForm.driver"></el-input>
                        <el-switch v-model="driverNameSwitch" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                    </div>
                </el-form-item>
                <el-form-item label="驾驶员电话：" prop="driverMobile" style="margin-bottom:8px;">
                    <div class="switch-style">
                        <el-input type="number" :disabled="!driverMobileSwitch" v-model="settlementUpdateForm.driverMobile"></el-input>
                        <el-switch v-model="driverMobileSwitch" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                    </div>
                </el-form-item>
                <el-form-item label="皮重：" prop="firstWeight" style="margin-bottom:8px;">
                    <div class="switch-style">
                        <el-input type="number"  @change="handlerFirstWeight" :disabled="!firstWeightSwitch" v-model="settlementUpdateForm.firstWeight"></el-input>
                        <el-switch v-model="firstWeightSwitch" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                    </div>
                </el-form-item>
                <el-form-item label="毛重：" prop="secondWeight" style="margin-bottom:8px;">
                    <div class="switch-style">
                        <el-input type="number" @change="handlerSecondWeight" :disabled="!secondWeightSwitch" v-model="settlementUpdateForm.secondWeight"></el-input>
                        <el-switch v-model="secondWeightSwitch" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                    </div>
                </el-form-item>
                <el-form-item label="净重：" prop="netWeight" style="margin-bottom:8px;width:86%;">
                    {{settlementUpdateForm.netWeight}}
                </el-form-item>
                <el-form-item label="总净重：" prop="netWeightAll" style="margin-bottom:8px;width:86%;">
                    {{settlementUpdateForm.netWeightAll}}
                </el-form-item>
                <el-form-item label="订单总价：" prop="orderTotalPrice" style="margin-bottom:8px;width:86%;">
                    {{settlementUpdateForm.orderTotalPrice}}
                </el-form-item>
                 <el-form-item label="备注：" prop="remark" style="width:86%;">
                    <el-input type="textarea" maxlength="100" show-word-limit v-model="settlementUpdateForm.remark"></el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" style="margin-left:40px;" plain :loading="is_post" @click="settlementUpdateSubmit">提 交 修 改</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </el-card>
</template>

<script>
import BMF from 'browser-md5-file';
const OSS = require('ali-oss');
import pdf from "vue-pdf"
import defaultSetting from '@/settings'
import request from '@/utils/request'
import {deepClone,parseTime} from '@/utils'
import {stringTrim} from '@/utils/elvalid'
import {getToken} from '@/utils/auth'
import poundDetail from '@/components/PoundDetail'

import can from "@/directive/can/index.js"
import {mapGetters} from 'vuex'


export default {
    name: 'order_detail',
    components:{
        pdf,
        poundDetail
    },
    computed:{
        ...mapGetters([
            'permissions'
        ])
    },
    directives:{can},
    data(){
        let validate_cut_price = (rule, value, callback)=>{
            if(parseFloat(value) >= parseFloat(this.priceForm.realPrice)){
                callback(new Error("优惠不能大于价格!"));
            }else{
                callback();
            }
        }

        return {
            is_ok:false,
            is_post:false,
            is_upload:false,
            data:null,
            dates:[],
            // deliverType:0,
            editForm:{
                orderId:0,
                expressName:"",
                plateNumber:"",
                carriageNumber:"",
                driverName:"",
                driverMobile:"",
                escortName:"",
                escortMobile:"",
                destinations:"",
                deliverType:0,
                planDate:""
            },
            poundInfo:{

            },
            selectForm:{
                // comId:""
            },
            fileList:[],
            editRules:{
                plateNumber:[
                    {required: true, message: '请输入主车号', trigger: 'blur'},
                    {pattern:/^[京津晋冀蒙辽吉黑沪苏浙皖闽赣鲁豫鄂湘粤桂琼渝川贵云藏陕甘青宁新][ABCDEFGHJKLMNPQRSTUVWXY][\dABCDEFGHJKLNMxPQRSTUVWXYZ]{5}$/,message:"请输入正确的主车号",trigger: 'blur'}
                ],
                carriageNumber:[
                    {required: true, message: '请输入挂车号', trigger: 'blur'},
                    {pattern:/^[京津晋冀蒙辽吉黑沪苏浙皖闽赣鲁豫鄂湘粤桂琼渝川贵云藏陕甘青宁新][ABCDEFGHJKLMNPQRSTUVWXY][0-9A-Z]{4}挂$/,message:"请输入正确的挂车号",trigger: 'blur'}
                ],
                driverName:[
                    {required: true, message: '请输入驾驶员', trigger: 'blur'},
                    { validator: stringTrim, trigger: 'blur' }
                ],
                // escortName:[
                //     { validator: stringTrim, trigger: 'blur' }
                // ],
                driverMobile:[
                    {required: true, message: '请输入驾驶员电话', trigger: 'blur'},
                    {pattern:/^1[345789]\d{9}$/,message:"请输入正确的驾驶员电话",trigger: 'blur'}
                ],
                escortMobile:[
                    {pattern:/^1[345789]\d{9}$/,message:"请输入正确的电话号码",trigger: 'blur'}
                ],
                expressName:[
                    // {required: true, message: '请输入物流公司名称', trigger: 'blur'},
                    // { validator: stringTrim, trigger: 'blur' }
                ]
            },
            priceForm:{
                ids:[],
                realPrice:"",
                saleCutPrice:""
            },
            priceRules:{
                realPrice:[
                    { required: true, message: '请输入实际价格', trigger: 'blur' },
                    {pattern:/^([1-9]\d*(\.\d{1,2})?|[0]{1}\.\d{1,2})$/,message:"请输入一个正数,最多保留2位小数",trigger: 'blur'}
                ],
                saleCutPrice:[
                    { required: true, message: '请输入销售优惠', trigger: 'blur' },
                    {pattern:/^([1-9]\d*(\.\d{1,2})?|[0]{1}\.\d{1,2}|0)$/,message:"请输入一个正数,最多保留2位小数",trigger: 'blur'},
                    { validator: validate_cut_price, trigger: 'blur' }
                ]
            },
            pound_dialog:false,
            edit_dialog:false,
            edit_price_dialog:false,
            chongzhuang:[],
            add_file_dialog:false,
            weightForm:{
                orderId:0,
                firstWeight:"",
                lastWeight:"",
                netWeight:"",
                startTime:"",
                endTime:"",
                files:[]
            },
            weightRules:{
                firstWeight:[
                    { required: true, message: '请输入皮重', trigger: 'blur' },
                    {pattern:/^([1-9]\d*(\.\d{1,2})?|[0]{1}\.\d{1,2})$/,message:"请输入一个正数,最多保留2位小数",trigger: 'blur'}
                ],
                lastWeight:[
                    { required: true, message: '请输入毛重', trigger: 'blur' },
                    {pattern:/^([1-9]\d*(\.\d{1,2})?|[0]{1}\.\d{1,2})$/,message:"请输入一个正数,最多保留2位小数",trigger: 'blur'}
                ],
                netWeight:[
                    { required: true, message: '请输入净重', trigger: 'blur' },
                    {pattern:/^([1-9]\d*(\.\d{1,2})?|[0]{1}\.\d{1,2})$/,message:"请输入一个正数,最多保留2位小数",trigger: 'blur'}
                ],
                startTime:[
                    { required: true, message: '请选择一次过磅时间', trigger: 'blur' },
                ],
                endTime:[
                    { required: true, message: '请选择二次过磅时间', trigger: 'blur' },
                ]
            },
            uploadOption:null,
            preview_dialog:false,
            numPages:null,
            preview_file:null,
            is_show_pdf:false,
            remark:"",
            upload_file_dialog:false,
            other_fee_dialog:false,
            fee_data:[],
            add_other_fee_dialog:false,
            leadForm:{
                weight:''
            },
            weigthForms:{
                weight:[
                    { required: true, message: '请输入计划量', trigger: 'blur' },
                    {pattern:/^([1-9]\d*(\.\d{1,2})?|[0]{1}\.\d{1,2})$/,message:"请输入一个数字,最多保留2位小数",trigger: 'blur'}
                ]
            },
            setLeadDialog:false,
            addOtherForm:{
                name:"",
                num:""
            },
            feeRules:{
                name:[
                    { required: true, message: '请输入其他费用名录', trigger: 'blur' },
                    { validator: stringTrim, trigger: 'blur' }
                ],
                num:[
                    { required: true, message: '请输入其他费用金额', trigger: 'blur' },
                    {pattern:/^([1-9]\d*(\.\d{1,2})?|[0]{1}\.\d{1,2})$/,message:"请输入一个数字,最多保留2位小数",trigger: 'blur'}
                ]
            },
            settlementUpdateDialog:false,
            settlementUpdateRules:{
                remark:[
                    { required: true, message: '请输入备注', trigger: 'blur' }
                ]
            },
            settlementUpdateForm:{
                id:'',
                price:'',
                poundSn:'',
                plateNumber:'',
                carriageNumber:'',
                driver:'',
                driverMobile:'',
                firstWeight:'',
                secondWeight:'',
                netWeight:'',
                netWeightAll:0,
                orderTotalPrice:'',
                remark:"",
            },
            plateNumberSwitch: false,
            settleUnitPriceSwitch: false,
            carriageNumberSwitch: false,
            driverNameSwitch: false,
            driverMobileSwitch: false,
            firstWeightSwitch: false,
            secondWeightSwitch: false,
            poundSnList:[],
        }
    },
    methods:{
        goBack(){
            this.$router.go(-1);
        },
        setOtherFee(){
            this.fee_data = JSON.parse(this.data.moneyInfo.otherFee);
            this.other_fee_dialog = true;
        },
        //修改基础信息
        editBtn(){
            this.editForm = {
                orderId:this.data.id,
                expressName:this.data.baseInfo.expressName,
                plateNumber:this.data.baseInfo.plateNumber,
                carriageNumber:this.data.baseInfo.carriageNumber,
                driverName:this.data.baseInfo.driverName,
                driverMobile:this.data.baseInfo.driverMobile,
                escortName:this.data.baseInfo.escortName,
                escortMobile:this.data.baseInfo.escortMobile,
                deliverType:this.data.baseInfo.deliverType,
                planDate:this.data.baseInfo.planDate,
                destinations:""
            };
            let arr = JSON.parse(this.data.baseInfo.destinations);
            if(arr.length > 0){
                this.editForm.destinations = arr.join("\n");
            }
            this.edit_dialog = true;
        },
        editPrice(){
            this.priceForm.ids = [this.data.id];
            this.priceForm.saleCutPrice = this.data.moneyInfo.saleCut;
            this.priceForm.realPrice = this.data.moneyInfo.realPrice;
            this.edit_price_dialog = true;
        },
        editSubmit(){
            this.$refs["editForm"].validate(valid=>{
                if(!valid) return false;
                this.is_post = true;
                this.editForm.destinations = this.editForm.destinations.length == 0?[]:this.editForm.destinations.split("\n");
                request.post("order/com_edit_info",this.editForm).then(res=>{
                    this.is_post = false;
                    this.getData().then(res=> {
                        this.data = res;
                    });
                    this.$message.success("修改基本信息成功!");
                    this.edit_dialog = false;
                }).catch(err=>{
                    console.log(err);
                    this.is_post = false;
                });
            });
        },
        querySearchExpressName(str,callback){
            request.post("company/logistics_supplier_option",{type:2,keyword:str}).then(res=>{
                if(res.data && res.data.length){
                    let arr = [];
                    for(let item of res.data){
                        arr.push({value:item.displayName});
                    }
                    callback(arr);
                }
            }).catch(err=>{
                console.log(err);
            });
        },
        has_permission(permission){
            return this.permissions.includes(permission);
        },
        //提交价格修改
        submitPriceChange(){
            this.$refs["priceForm"].validate(valid=>{
                if(!valid) return false;
                this.is_post = true;
                request.post("order/com_edit_price",this.priceForm).then(res=>{
                    this.is_post = false;
                    this.getData().then(res=>{
                        this.data = res;
                        this.remark = res.remark;
                        this.edit_price_dialog = false;
                        this.$message.success("调价操作成功!");
                    });
                }).catch(err=>{
                    this.is_post = false;
                });
            });
        },
        add_weight_btn(){
            this.add_file_dialog = true;
        },
        delFile(file,index){
            this.fileList.splice(index,1);
        },
        uploadSuccess(file){
            this.$message.success(`上传文件(${file.name})成功!`);
            this.fileList.push(file);
        },
        async preview(file,index){
            if(file.fileType == "pdf"){
                //pdf
                this.preview_file = file;
                this.preview_dialog = true;
                this.is_show_pdf = true;
                await this.getNumPages(file.url);
                this.is_show_pdf = false;
            }else{
                this.preview_file = file;
                this.preview_dialog = true;
            }
        },
        uploadFile(e){
            let {file} = e;
            if(this.fileList.length >= 4){
                this.$message.warning("最多只能上传4个附件!");
                return false;
            }
            if(!["application/pdf","image/jpeg","image/png"].includes(file.type)){
                this.$message.warning("只支持pdf,jpeg,jpg,png文件!");
                return false;
            }
            if(file.size > 1024*1024*20){
                this.$message.warning("文件最大支持上传20MB!");
                return false;
            }
            let errobj = {
                type:"",//size|mime|other
                msg:""
            };
            const bmf = new BMF();
            bmf.md5(file,(err, md5) => {
                //生成文件名
                let filename = md5+file.name.substring(file.name.lastIndexOf("."));
                let oldname = file.name;
                //文件夹
                let folder = "attach_file";
                //上传
                let readerBlob = new FileReader();
                readerBlob.onload = async (event)=>{
                    let data = new OSS.Buffer(event.target.result);
                    let client = new OSS(this.uploadOption);
                    try {
                        let result = await client.put(folder+"/"+filename, data);
                        let obj = {name:oldname,url:result.url,type:file.name.substring(file.name.lastIndexOf(".")+1)};
                        this.uploadSuccess(obj);
                    } catch (e) {
                        errobj.type = "other";
                        errobj.msg = e;
                        this.$message.warning(e.message);
                        return errobj;
                    }
                };
                readerBlob.readAsArrayBuffer(file);
            });
        },
        getNumPages(url) {
            return new Promise((resolve,reject)=>{
                let loadingTask = pdf.createLoadingTask(url)
                loadingTask.promise.then(pdf => {
                    this.numPages = pdf.numPages
                    resolve();
                }).catch(err => {
                    console.error('pdf 加载失败', err);
                    this.is_show_pdf = false;
                    reject(err);
                })
            });
        },
        async beforeUpload(file){
            if(this.fileList.length >= 4){
                return false;
            }
            if(!["application/pdf","image/jpeg","image/png"].includes(file.type)){
                return false;
            }
            if(file.size > 1024*1024*20){
                return false;
            }
            try{
                this.uploadOption = await this.$store.dispatch("upload/getAccessToken");
            } catch(e){
                this.$message.warning(e.message);
                return false;
            }
            return true;
        },
        getData(is_init = false){
            return new Promise((resolve, reject)=>{
                if(!is_init){
                    this.is_post = true;
                }
                let id = this.$route.params.id;
                request.get("order/detail?id="+id).then(res=>{
                    if(!is_init){
                        this.is_post = false;
                    }else{
                        this.is_ok = true;
                    }
                    resolve(res.data);
                }).catch(err=>{
                    if(!is_init){
                        this.is_post = false;
                    }else{
                        this.is_ok = true;
                    }
                    reject(err);
                });
            });
        },
        getPoundData(poundSn){
            this.is_post = true;
            request.post("order/pound_detail",{id:this.data.id,poundSn:poundSn}).then(res=>{
                this.is_post = false;
                this.poundInfo = res.data;
                this.pound_dialog = true;
            }).catch(err=>{
                this.is_post = false;
            });
        },
        parseStatus(num) {
            switch (num) {
            case 0:
                return "待审核";
            case 10:
                return "已审核"; //待打卡
            case 15:
                return "已打卡"; //待登记
            case 16:
                return "已登记"; //待入场安检
            case 21:
                return "入厂安检"; //待一次过磅
            case 23:
                return "一次过磅";//待充装
            case 24:
                return "已充装"; //待出厂安检
            case 26:
                return "出厂安检"; //待二次过磅
            case 27:
                return "二次过磅"; //待打印
            case 30:
                return "已完成"; //已打印
            case 90:
                return "客户取消";
            case 91:
                return "液厂取消";
            case 92:
                return "已过期";
            }
        },
        statusType(n){
            if(n < 10){
                return "warning";
            }else if(n >= 10 && n < 20){
                return "primary";
            }else if(n >= 20 && n <=30){
                return "success";
            }else if(n>89){
                return "danger";
            }
        },
        parseChangeType(actionType){
            switch(actionType){
                case 0:
                    return "后台创建计划单";
                case 1:
                    return "客户创建计划单";
                case 2:
                    return "后台修改计划单";
                case 3:
                    return "客户修改计划单";
                case 4:
                    return "司机填写槽车检验单";
                case 5:
                    return "销售调价";
                case 10:
                    return "司机打卡";
                case 20:
                    return "登记";
                case 30:
                    return "安检";
                case 40:
                    return "过磅";
                case 50:
                    return "充装检验";
                case 60:
                    return "标记罐压高";
                case 90:
                    return "客户取消";
                case 91:
                    return "液厂驳回";
            }
        },
        //补录磅单
        add_weight_submit(){
            this.$refs["weightForm"].validate(valid=>{
                if(!valid) return false;
                this.is_post = true;
                this.weightForm.orderId = this.data.id;
                this.weightForm.files = deepClone(this.fileList);
                request.post("order/make_up_weight",this.weightForm).then(res=>{
                    this.$message.success("磅单补录完成");
                    this.is_post = false;
                    this.getData();
                    this.add_file_dialog = false;
                    this.$refs["weightForm"].resetFields();
                }).catch(err=>{
                    this.is_post = false;
                });
            });
        },
        //上传图片
        upload_file_btn(){
            this.$refs["addFile"].click();
        },
        file_change(e){
            let file = e.target.files[0];
            if(!["application/pdf","image/jpeg","image/png","image/gif"].includes(file.type) ){
                this.$message.warning("只能上传jpg,jpeg,png,gif,pdf格式的文件!");
                e.target.value = "";
                return false;
            }
            if(file.size > 20 * 1024 * 1024){
                this.$message.warning("附件不能大于20MB!");
                e.target.value = "";
                return false;
            }
            this.is_upload = true;
            this.$store.dispatch("upload/uploadFile",{file}).then(res=>{
                this.is_post = true;
                request.post("order/add_weight_attach",{orderId:this.data.id,...res}).then(r=>{
                    this.$message.success("上传附件成功");
                    res.fileType = res.type;
                    this.data.weightInfo.files.push(deepClone(res));
                    this.is_post = false;
                }).catch(err=>{
                    this.is_post = false;
                });
                this.is_upload = false;
            }).catch(err=>{
                this.is_upload = false;
            });
        },
        update_remark(){
            this.is_post = true;
            request.post("order/edit_remark",{id:this.data.id,remark:this.remark}).then(res=>{
                this.is_post = false;
                this.$message.success("更新备注成功");
            }).catch(err=>{
                this.is_post = false;
            });
        },
        //添加
        addOther(){
            this.$refs["addOtherForm"].validate(valid=>{
                if(!valid) return false;
                this.fee_data.push(deepClone(this.addOtherForm));
                this.$refs["addOtherForm"].resetFields();
                this.addOtherForm = {
                    name:"",
                    num: ""
                };
                this.add_other_fee_dialog = false;
            });
        },
        delOther(i){
            this.fee_data.splice(i,1);
        },
        //保存
        saveOtherFee(){
            this.is_post = true;
            request.post("order/edit_other_fee",{id:this.data.id,otherFee:JSON.stringify(this.fee_data)}).then(res=>{
                this.is_post = false;
                this.$message.success("其他费用保存成功!");
                this.data = res.data;
                this.other_fee_dialog = false;
            }).catch(err=>{
                this.is_post = false;
            });
        },
        //修改计划量
        amountBtn(item){
            this.leadForm.orderId=item.id;
            this.setLeadDialog=true;
        },
        setLeadSubmit(){
            this.$refs['leadForm'].validate(values=>{
                if(!values) return false;
                if(this.leadForm.weight>22.5)return this.$message.error('计划量不能大于22.5')
                request.post('/order/edit/weight',this.leadForm).then(res=>{
                    if(res.code==200){
                        this.getData().then(res=>{
                            this.data = res;
                        });
                        this.$message.success('计划量修改成功')
                        this.setLeadDialog=false;

                    }
                })
            })
        },
        showPoundDetail(){

        },
        //更新结算信息
        settlementUpdateBtn(item){
            this.settlementUpdateDialog=true;
            this.settlementUpdateForm.id=item.id;
            this.getPoundSn(item.id);
            this.settlementUpdateForm.price=item.moneyInfo.tradingPrice;
            this.settlementUpdateForm.plateNumber=item.baseInfo.plateNumber;
            this.settlementUpdateForm.carriageNumber=item.baseInfo.carriageNumber;
            this.settlementUpdateForm.driver=item.baseInfo.driverName;
            this.settlementUpdateForm.driverMobile=item.baseInfo.driverMobile;
        },
        getPoundSn(id){
            request.post('order/ps_dropdown',{id:id}).then(res=>{
                    if(res.code==200){
                        this.poundSnList=res.data;
                        this.settlementUpdateForm.poundSn=this.poundSnList[0].poundSn;
                        this.settlementUpdateForm.firstWeight=this.poundSnList[0].firstWeight;
                        this.settlementUpdateForm.secondWeight=this.poundSnList[0].secondWeight;
                        this.settlementUpdateForm.netWeight=parseFloat(this.poundSnList[0].secondWeight-this.poundSnList[0].firstWeight).toFixed(2);
                        //获取总净重
                        let netWeightAlla=0;
                        for (let item of this.poundSnList) {
                            netWeightAlla += parseFloat(item.secondWeight).toFixed(2)-parseFloat(item.firstWeight).toFixed(2);
                        }
                        this.settlementUpdateForm.netWeightAll=parseFloat(netWeightAlla).toFixed(2);
                        // 获取订单总价
                        this.settlementUpdateForm.orderTotalPrice=parseFloat(this.settlementUpdateForm.price*this.settlementUpdateForm.netWeightAll).toFixed(2);
                    }
                })
        },
        changePoundSn(e){
            for (let item of this.poundSnList) {
                if(item.poundSn==e){
                    this.settlementUpdateForm.poundSn=item.poundSn;
                    this.settlementUpdateForm.firstWeight=item.firstWeight;
                    this.settlementUpdateForm.secondWeight=item.secondWeight;
                    this.settlementUpdateForm.netWeight=parseFloat(item.secondWeight-item.firstWeight).toFixed(2);
                }
            }
        },
        handlerPrice(e){
            this.settlementUpdateForm.price=e;
            this.settlementUpdateForm.orderTotalPrice=parseFloat(this.settlementUpdateForm.price*this.settlementUpdateForm.netWeightAll).toFixed(2);
        },
        handlerFirstWeight(e){
            this.settlementUpdateForm.firstWeight=e;
            this.settlementUpdateForm.netWeight=parseFloat(this.settlementUpdateForm.secondWeight-this.settlementUpdateForm.firstWeight).toFixed(2);
            let netWeightAll1=0;
            for (let item of this.poundSnList) {
                if(this.settlementUpdateForm.poundSn!=item.poundSn){
                     netWeightAll1+=item.secondWeight-item.firstWeight;
                }
            }
            this.settlementUpdateForm.netWeightAll=parseFloat(this.settlementUpdateForm.secondWeight-this.settlementUpdateForm.firstWeight+netWeightAll1).toFixed(2);
            this.settlementUpdateForm.orderTotalPrice=parseFloat(this.settlementUpdateForm.price*this.settlementUpdateForm.netWeightAll).toFixed(2);
        },
        handlerSecondWeight(e){
            this.settlementUpdateForm.secondWeight=e;
            this.settlementUpdateForm.netWeight=parseFloat(this.settlementUpdateForm.secondWeight-this.settlementUpdateForm.firstWeight).toFixed(2);
            let netWeightAll1=0;
            for (let item of this.poundSnList) {
                if(this.settlementUpdateForm.poundSn!=item.poundSn){
                     netWeightAll1+=item.secondWeight-item.firstWeight;
                }
            }
            this.settlementUpdateForm.netWeightAll=parseFloat(this.settlementUpdateForm.secondWeight-this.settlementUpdateForm.firstWeight+netWeightAll1).toFixed(2);;
            this.settlementUpdateForm.orderTotalPrice=parseFloat(this.settlementUpdateForm.price*this.settlementUpdateForm.netWeightAll).toFixed(2);
        },
        // 提交更新结算信息
        settlementUpdateSubmit(){
            this.$refs['settlementUpdateForm'].validate(values=>{
                if(!values) return false;
                this.$confirm('此操作将更新结算信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    request.post('/order/edit_history',this.settlementUpdateForm).then(res=>{
                        if(res.code==200){
                            this.$message.success('更新结算信息成功')
                            this.settlementUpdateDialog=false;
                        }else{
                            this.$message.error(res.msg);
                        }
                    })
                }).catch(() => {
                    this.$message.error('已取消更新');
                });
            })
        },
        async exportExcel(){
             let id = this.$route.params.id;
            try{
                let res = await fetch(this.baseUrl+"/order/inspection_sheet_download/"+id,{
                    method:"GET",
                    headers:{
                        "Authorization":getToken(),
                        "Content-Type":"application/json;charset=utf-8"
                    },
                });
                let blob = await res.blob();
                const a= document.createElement("a")
                a.href = URL.createObjectURL(blob)
                a.download = "槽车充装检验单.xls"
                a.click()
                URL.revokeObjectURL(a.href)
                this.$message.success("导出成功!");
            }catch(err){
            }finally {
            }
        },

    },
    created() {
        this.baseUrl = process.env.VUE_APP_BASE_API+"/"+defaultSetting.api_version;
        let time = new Date();
        this.dates.push(parseTime(time,"{y}-{m}-{d}"));
        time = time.getTime()+86400000;
        this.dates.push(parseTime(time,"{y}-{m}-{d}"));
    },
    mounted() {

        this.getData(true).then(res=>{
            this.data = res;
            this.deliverType = this.data.baseInfo.deliverType
            this.remark = res.remark;
            let route = this.$route;
            if(typeof route.query["type"] != "undefined" && route.query["type"]){
                if(route.query["type"] == "edit"){
                    this.editBtn();
                }else if(route.query["type"] == "weight"){
                    this.add_weight_btn();
                }
            }
        }).catch(err=>{
            console.log(err);
        });
    }
}
</script>

<style scoped lang="scss">
.switch-style{
    display: flex;
    align-content: center;
    width: 96%;
}
.el-switch{
    margin-top: 7px;
    margin-left: 10px;
}
.previews{
    display: flex;
    align-items: center;
    flex-wrap:wrap;
    width: 100%;
    .preview{
        width: 160px;
        height: 140px;
        border: 1px dashed #ddd;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin-right: 15px;
        position: relative;
        margin-bottom: 15px;
        box-shadow:1px 1px 4px #aaa;
        &.pdf{
            padding: 0 10px;
        }

        &:hover{
            border-color: #1890ff;
            .img_btns{
                display: flex;
            }
        }

        .text{
            line-height: 15px;
            width: 100%;
            font-size: 12px;
            color: #bbb;
            margin-top: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            text-align: center;
        }

        .img_btns{
            display: none;
            background: rgba(0,0,0,0.6);
            border-radius: 10px;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            justify-content: center;
            align-items: center;
        }

        .btns{
            font-size: 16px;
        }
        .pdf_icon{
            font-size: 50px;
            font-weight: 700;
            color: #bbb;
        }

    }
}
</style>
